import React, { useState } from 'react';
import styled from 'styled-components';
import { Card, Dialog } from '@mui/material';
import TicketForm from '../../../components/templates/tickets/TicketForm';
import { Icon } from '@iconify/react';
import FormSettlements from '../../../components/ui/organisms/faculty/FormSettlements';
import { useErpPa } from '../contexts/ErpPaProvider';

const TeacherInteractionButtons = (props) => {
    const { handleRefresh } = props;

    const { erpPaId } = useErpPa();
    const [openDialog, setOpenDialog] = useState(false);
    const [openTicketModal, setOpenTicketModal] = useState(false);
    const handleDialog = () => setOpenDialog(!openDialog);

    return (
        <Wrapper>
            <Header>
                <TicketButtonWrapper>
                    <ScheduleButton
                        href="https://calendly.com/nbraconi"
                        target="_blank"
                    >
                        <Icon icon="ph:calendar" width="24px" height="24px" />
                        <div>
                            <label>Agendar consulta</label>
                        </div>
                    </ScheduleButton>
                    <TicketButton
                        onClick={() => {
                            setOpenTicketModal(true);
                        }}
                    >
                        <Icon
                            icon="ph:warning-bold"
                            width="24px"
                            height="24px"
                        />
                        <div>
                            <label>Reportar problema</label>
                        </div>
                    </TicketButton>
                </TicketButtonWrapper>
                {openTicketModal && (
                    <ModalWrapper>
                        <ModalContainer>
                            <TicketForm
                                open={openTicketModal}
                                setOpen={setOpenTicketModal}
                                // proyectID 56 es de Tesorería - Honorarios
                                proyectId={56}
                                title="Generación de ticket por solicitud o incidente"
                                subtitle="Completa el siguiente formulario para generar un ticket"
                            />
                        </ModalContainer>
                    </ModalWrapper>
                )}
                {erpPaId && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDialog}
                    >
                        Cargar liquidación
                    </Button>
                )}
            </Header>
            <Dialog open={openDialog} onClose={handleDialog}>
                <FormSettlements
                    handleRefresh={handleRefresh}
                    onClose={handleDialog}
                    erpPaId={erpPaId}
                />
            </Dialog>
        </Wrapper>
    );
};

export default TeacherInteractionButtons;

const Wrapper = styled(Card)`
    display: flex;
    width: calc(100% - 4rem);
    padding: 1rem 2rem;
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem 0;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 1rem;
    }
`;

const ModalWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #00000080;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ModalContainer = styled.div`
    height: 85vh;
    width: 40vw;
    background-color: #fff;
    padding: 2rem;
    border-radius: 20px;
    overflow-y: auto;
    position: relative;
    scrollbar-color: transparent transparent;

    @media (width < 768px) {
        width: 80vw;
    }
`;
const Button = styled.button`
    width: fit-content;
    height: 40px;
    padding: 0 2rem;
    border-radius: 20px;
    background-color: #cd2118;
    color: #fff;
    white-space: nowrap;
    font-weight: 700;
    cursor: pointer;

    :hover {
        background-color: #b13d15;
        box-shadow:
            0px 8px 8px -4px #18274b0a,
            0px 4px 6px -4px #18274b0a;
    }

    @media (width < 768px) {
        width: 100%;
        padding: 12px 0;
    }
`;
const TicketButtonWrapper = styled.div`
    width: calc(100% - 4rem);
    display: flex;
    justify-content: end;
    gap: 2rem;
    padding: 0 2rem;

    @media (width < 768px) {
        width: 100%;
    }
`;

const TicketButton = styled.button`
    cursor: pointer;
    width: fit-content;
    height: 40px;
    background-color: #fff;
    color: #cd2118;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    padding: 1rem;
    border: 2px solid #cd2118;

    &:hover {
        box-shadow: none;
        color: #b31d15;
        border: 2px solid #b31d15;
        box-shadow:
            0px 8px 8px -4px #18274b0a,
            0px 4px 6px -4px #18274b0a;
    }

    div {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 4px;

        label {
            cursor: pointer;
            color: #b31d15;
            font-weight: bold;
        }
    }

    @media (width < 768px) {
        width: calc(50%);
        padding: 0;
    }
`;
const ScheduleButton = styled.a`
    cursor: pointer;
    width: fit-content;
    height: 36px;
    background-color: #fff;
    color: #cd2118;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    padding: 0 1rem;
    border: 2px solid #cd2118;

    &:hover {
        box-shadow: none;
        color: #b31d15;
        border: 2px solid #b31d15;
        box-shadow:
            0px 8px 8px -4px #18274b0a,
            0px 4px 6px -4px #18274b0a;
    }

    div {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 4px;

        label {
            cursor: pointer;
            color: #b31d15;
            font-weight: bold;
            font-size: 14px;

            @media (width < 768px) {
                font-size: 12px;
                white-space: nowrap;
            }
        }
    }

    @media (width < 768px) {
        width: calc(49%);
        padding: 0;
    }
`;
